interface Config {
  api: {
    baseUrl: string;
    wsUrl: string;
  };
  auth: {
    googleAuthUrl: string;
  };
  app: {
    name: string;
    version: string;
  };
}

// Определяем режим работы
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// В production используем текущий домен, в development - localhost
const getBaseUrl = () => {
  if (isProduction) {
    // В production используем текущий origin (https://legend-rebirth.com)
    return window.location.origin;
  }
  // В development используем переменную окружения или localhost
  return process.env.REACT_APP_API_URL || 'http://localhost:5001';
};

const getWsUrl = () => {
  if (isProduction) {
    // В production используем wss:// для безопасного соединения
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}`;
  }
  // В development используем переменную окружения или localhost
  return process.env.REACT_APP_WS_URL || 'http://localhost:5001';
};

const baseUrl = getBaseUrl();
const wsUrl = getWsUrl();

const config: Config = {
  api: {
    baseUrl,
    wsUrl
  },
  auth: {
    googleAuthUrl: `${baseUrl}/auth/google`
  },
  app: {
    name: 'FIGHT Game',
    version: '1.0.0'
  }
};

// Логирование конфигурации для отладки
if (isDevelopment) {
  console.log('App Config:', {
    environment: process.env.NODE_ENV,
    baseUrl: config.api.baseUrl,
    wsUrl: config.api.wsUrl,
    googleAuthUrl: config.auth.googleAuthUrl
  });
}

export default config;
